document.addEventListener('DOMContentLoaded', (event) => {
    //define global variables
    const isTabletOrMobile = () => {
        return window.innerWidth <= 1024;
    };
    const isMobile = () => {
        return window.innerWidth <= 767;
    };
    if (isMobile) {
        initAccordionMobile();
    }
    initCarousel();
    initMegaMenu();
    initAccordionDesktop();
    saveMedicalSessionStorage();
    initImageBlogArticle();
    const contactForm = document.querySelector('.contact-form-section');
    const buyProductBlock = document.querySelector('.product-buying-selector-block');
    const asideBlock = document.querySelector('.aside');
    const blogPage = document.querySelector('.blog-main');
    const urlstring = window.location.href;
    const actualurl = new URL(urlstring);
    initHeadingAnimation();
    //initSwitchLanguage();
    initIubendaForm();
    jsLazyLoadImages();
    if (contactForm) {
        initFormValidation();
        initFormResponseHandler(actualurl);
        initFormSelection();
    }
    if (buyProductBlock) {
        initProductSelection();
        initProductModalResponseHandler(actualurl);
    }
    if (asideBlock) {
        initNavLinkSelector();
    }
    if (blogPage) {
        initLoadMore();
    }
});
